import React, { useState } from "react";
import { OutsideEventBehavior } from "@8x8/oxygen-utils";
import { usePopper as usePopperPosition } from "react-popper";
import PropTypes from "prop-types";
import { createPortal } from "react-dom";

import StyledContextualDropDown from "@/react/components/contextual-drop-down/StyledContextualDropDownWrapper";
import { ThemeProvider } from "styled-components";
import { withTheme } from "@8x8/oxygen-config";
import { REACT_APP_ID } from "@/react/routing/constants";
import { usePopper } from "@/react/components/poppers";

const ContextualDropDown = ({
  children,
  dropdownKey,
  renderTargetElement,
  testId,
  theme,
  popperPlacement,
  popperModifiers,
  onClickOutside,
}) => {
  const { isOpen, openByKey, closeAll } = usePopper(dropdownKey);
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);

  const { styles, attributes } = usePopperPosition(
    referenceElement,
    popperElement,
    {
      placement: popperPlacement || "bottom-start",
      modifiers: [...(popperModifiers || [])],
    }
  );

  return (
    <ThemeProvider theme={theme}>
      {renderTargetElement({
        ref: setReferenceElement,
        onClick: () => {
          if (isOpen) {
            // Close the popper if it's already open
            closeAll();
          } else {
            // Close all poppers first, then open the current one
            closeAll();
            openByKey();
          }
        },
      })}
      <OutsideEventBehavior onClick={onClickOutside}>
        {isOpen &&
          createPortal(
            <StyledContextualDropDown
              data-test-id={testId}
              ref={setPopperElement}
              style={styles.popper}
              {...attributes.popper}
            >
              {children}
            </StyledContextualDropDown>,
            document.getElementById(REACT_APP_ID)
          )}
      </OutsideEventBehavior>
    </ThemeProvider>
  );
};

ContextualDropDown.propTypes = {
  children: PropTypes.node,
  dropdownKey: PropTypes.string.isRequired,
  renderTargetElement: PropTypes.func.isRequired,
  testId: PropTypes.string,
  theme: PropTypes.object,
  popperPlacement: PropTypes.string,
  popperModifiers: PropTypes.object,
  onClickOutside: PropTypes.func.isRequired,
};

export default withTheme(ContextualDropDown, "dropdownButton");
